import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import AppRoutes from './AppRoute';
// import "./fonts/style.css"
import { useNavigate, useLocation } from 'react-router-dom';
import React, { useEffect, lazy } from 'react'
import { Helmet } from "react-helmet";
import { handleLanguage } from './util/siteUtil';

const BannerRight = lazy(() => import("./components/Home/Banner/BannerRight"))
const BannerLeft = lazy(() => import("./components/Home/Banner/BannerLeft"))
const Footer = lazy(() => import("./components/Footer/Footer"))
const Navbar = lazy(() => import("./components/Navbar/Navbar"))

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    handleLanguage(location, navigate);
  }, [])

  useEffect(()=>{
    window.scrollTo(0, 0)
  },[location.pathname])

  return (
    <div className={`App${location.pathname.match("course") ? ' course-app' : ''}${process.env.REACT_APP_COLOR ? ' ' + process.env.REACT_APP_COLOR : ''}`}>
      <Helmet>
        <title>{process.env.REACT_APP_SITE_TITLE} | Luiss</title>
        <meta name="description" content={process.env.REACT_APP_DESCRIPTION}/>
      </Helmet>
      <Navbar />
      <AppRoutes />
      <BannerRight />
      <BannerLeft />
      <Footer />
    </div>
  );
}

export default App;
